<template>
    <div>
        <h1 class="display-heading">Clinic Profile</h1>
        <div class="card mb-3">
            <div class="card-body">
                <div class="mb-2">
                        <b>User Details</b>
                    </div>
                <div class="row">
                    <div class="form-group required col-12 col-lg-6">
                        <label>Email</label>
                        <input type="text" name="email" data-vv-validate-on="blur" data-vv-as="email"
                            placeholder="Email" v-model="email" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('email')
                        }">
                        <div v-show="validationErrors.has('email')" class="invalid-feedback">
                            {{ validationErrors.first('email') }}
                        </div>
                    </div>
                    <div class="form-group required col-12 col-lg-6">
                        <label>Phone Number</label>
                        <input type="text" name="phone" data-vv-validate-on="blur" data-vv-as="phone"
                            placeholder="Phone" v-model="phone" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('phone')
                        }">
                        <div v-show="validationErrors.has('phone')" class="invalid-feedback">
                            {{ validationErrors.first('phone') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>General Details</b>
                        </div>

                        <div class="form-group required">
                            <label>Clinic Name</label>
                            <input type="text" name="name" data-vv-validate-on="blur" data-vv-as="name"
                                placeholder="Clinic Name" v-model="name" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('name')
                            }">
                            <div v-show="validationErrors.has('name')" class="invalid-feedback">
                                {{ validationErrors.first('name') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Languages Speak</label>
                            <input style="opacity:0;" :class="{ 'is-invalid':  languagesSpeakHasError }">
                            <div v-show="languagesSpeakHasError" class="invalid-feedback mb-2">
                                The languages speak field is required.
                            </div>
                            <div class="row">
                                <div class="col-6 not-required" v-for="language in languages" :key="language">
                                    <input type="checkbox" :id="language" :value="language" v-model="languagesSpeak">
                                    <label class="ml-2" :for="language">{{ language }}</label>
                                </div>
                            </div>
                            <!-- <input type="text" name="languagesSpeak" data-vv-validate-on="blur" data-vv-as="languages speak" placeholder="Languages(s) Speak" v-model="languagesSpeak" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('languagesSpeak')
                            }">
                            <small>Separate multiple languages by a comma (,)</small> -->

                        </div>

                        <div class="form-group">
                            <label>Internet Provider (Optional)</label>
                            <input type="text" name="internetProvider" data-vv-validate-on="blur" data-vv-as="internet provider"
                                placeholder="Internet Provider" v-model="internetProvider" v-validate="''" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('internetProvider')
                            }">
                            <div v-show="validationErrors.has('internetProvider')" class="invalid-feedback">
                                {{ validationErrors.first('internetProvider') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Bank Account Details</b>
                        </div>

                        <div class="form-group required">
                            <label>Bank Account Payee Name</label>
                            <input type="text" name="bankAccountPayeeName" data-vv-validate-on="blur" data-vv-as="bank account payee name"
                                placeholder="Bank Account Payee Name" v-model="bankAccountPayeeName" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('bankAccountPayeeName')
                            }">
                            <div v-show="validationErrors.has('bankAccountPayeeName')" class="invalid-feedback">
                                {{ validationErrors.first('bankAccountPayeeName') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Bank Name</label>
                            <input type="text" name="bankName" data-vv-validate-on="blur" data-vv-as="bank name"
                                placeholder="Bank Name" v-model="bankName" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('bankName')
                            }">
                            <div v-show="validationErrors.has('bankName')" class="invalid-feedback">
                                {{ validationErrors.first('bankName') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Bank Account Number</label>
                            <input type="text" name="bankAccountNumber" data-vv-validate-on="blur" data-vv-as="bank account number"
                                placeholder="Bank Account Number" v-model="bankAccountNumber" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('bankAccountNumber')
                            }">
                            <div v-show="validationErrors.has('bankAccountNumber')" class="invalid-feedback">
                                {{ validationErrors.first('bankAccountNumber') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <div class="mb-2">
                    <b>Contact Details</b>
                    <div class="row">
                        <div class="form-group required col-12 col-lg-3">
                            <label>Contact Person Designation</label>
                            <input type="text" name="contactPersonDesignation" data-vv-validate-on="blur" data-vv-as="contact person designation"
                                placeholder="E.g. Mr., Mrs, Dr., Dato Sri" v-model="contactPersonDesignation" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('contactPersonDesignation')
                            }">
                            <div v-show="validationErrors.has('contactPersonDesignation')" class="invalid-feedback">
                                {{ validationErrors.first('contactPersonDesignation') }}
                            </div>
                        </div>

                        <div class="form-group required col-12 col-lg-9">
                            <label>Contact Person</label>
                            <input type="text" name="contactPerson" data-vv-validate-on="blur" data-vv-as="contact person"
                                placeholder="Contact Person" v-model="contactPerson" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('contactPerson')
                            }">
                            <div v-show="validationErrors.has('contactPerson')" class="invalid-feedback">
                                {{ validationErrors.first('contactPerson') }}
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group required col-12 col-lg-6">
                            <label>{{ clinicType === 2 ? 'Practice' : 'Clinic' }} Phone</label>
                            <input type="text" name="clinicPhone" data-vv-validate-on="blur" data-vv-as="clinic phone"
                                :placeholder="clinicType === 2 ? 'Practice Phone' : 'Clinic Phone'" v-model="clinicPhone" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('clinicPhone')
                            }">
                            <div v-show="validationErrors.has('clinicPhone')" class="invalid-feedback">
                                {{ validationErrors.first('clinicPhone') }}
                            </div>
                        </div>

                        <div class="form-group required col-12 col-lg-6">
                            <label>{{ clinicType === 2 ? 'Practice' : 'Clinic' }} Email</label>
                            <input type="text" name="clinicEmail" data-vv-validate-on="blur" data-vv-as="clinic email"
                                :placeholder="clinicType === 2 ? 'Practice Email' : 'Clinic Email'" v-model="clinicEmail" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('clinicEmail')
                            }">
                            <div v-show="validationErrors.has('clinicEmail')" class="invalid-feedback">
                                {{ validationErrors.first('clinicEmail') }}
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col-12 col-lg-6">
                            <label>Fax</label>
                            <input type="text" name="fax" data-vv-validate-on="blur" data-vv-as="fax"
                                placeholder="Fax" v-model="fax" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('fax')
                            }">
                            <div v-show="validationErrors.has('fax')" class="invalid-feedback">
                                {{ validationErrors.first('fax') }}
                            </div>
                        </div>

                        <div class="form-group col-12 col-lg-6">
                            <label>Website</label>
                            <input type="text" name="website" data-vv-validate-on="blur" data-vv-as="website"
                                placeholder="Website" v-model="website" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('website')
                            }">
                            <div v-show="validationErrors.has('website')" class="invalid-feedback">
                                {{ validationErrors.first('website') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <div class="mb-2">
                    <b>Location Details</b>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="place-map">
                            <div class="mb-2">
                                <p>Adjust red marker to desired location.</p>
                                <p class="text-danger">Click "Get Location" to retrieve latitude and longitude.</p>
                            </div>
                            <div class="place-gmaps-wrapper">
                                <div :id="mapId" class="google-map" :style="
                                {
                                    height:`${mapHeight}px`
                                }">
                                </div>
                                <div class="map-search-wrapper">
                                    <div class="input-group">
                                        <input :id="searchBoxId" type="text" class="form-control mr-1" placeholder="Search location"
                                        v-model="currentAddress">
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button" @click="getGmapLatLng">
                                                Get Location
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="map-edit-cursor"
                                    :style="cursorPosition">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="row">
                            <div class="col-12 font-italic font-weight-bold" style="font-size: 14px;">
                                Please confirm your Geolocation
                            </div>
                            <div class="form-group required col-12 col-md-6">
                                <label>Latitude</label>
                                <input disabled type="text" name="lat" data-vv-validate-on="blur" data-vv-as="latitude"
                                    placeholder="Latitude" v-model="lat" v-validate="'required'" :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('lat')
                                }">
                                <div v-show="validationErrors.has('lat')" class="invalid-feedback">
                                    {{ validationErrors.first('lat') }}
                                </div>
                            </div>

                            <div class="form-group required col-12 col-md-6">
                                <label>Longitude</label>
                                <input disabled type="text" name="long" data-vv-validate-on="blur" data-vv-as="longitude"
                                    placeholder="Longitude" v-model="long" v-validate="'required'" :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('long')
                                }">
                                <div v-show="validationErrors.has('long')" class="invalid-feedback">
                                    {{ validationErrors.first('long') }}
                                </div>
                            </div>
                        </div>

                        <div class="font-weight-bold font-italic" style="font-size: 14px; color:red;">
                            Please fill up
                        </div>

                        <div class="form-group required">
                            <label>Address Line 1</label>
                            <input type="text" name="addressLine1" data-vv-validate-on="blur" data-vv-as="address line 1"
                                placeholder="Address Line 1" v-model="addressLine1" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressLine1')
                            }">
                            <div v-show="validationErrors.has('addressLine1')" class="invalid-feedback">
                                {{ validationErrors.first('addressLine1') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Address Line 2</label>
                            <input type="text" name="addressLine2" data-vv-validate-on="blur" data-vv-as="address line 2"
                                placeholder="Address Line 2" v-model="addressLine2" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressLine2')
                            }">
                            <div v-show="validationErrors.has('addressLine2')" class="invalid-feedback">
                                {{ validationErrors.first('addressLine2') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>City</label>
                            <input type="text" name="addressCity" data-vv-validate-on="blur" data-vv-as="address city"
                                placeholder="City" v-model="addressCity" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressCity')
                            }">
                            <div v-show="validationErrors.has('addressCity')" class="invalid-feedback">
                                {{ validationErrors.first('addressCity') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>State</label>
                            <input type="text" name="addressState" data-vv-validate-on="blur" data-vv-as="address state"
                                placeholder="State" v-model="addressState" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressState')
                            }">
                            <div v-show="validationErrors.has('addressState')" class="invalid-feedback">
                                {{ validationErrors.first('addressState') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Postcode</label>
                            <input type="text" name="addressPoscode" data-vv-validate-on="blur" data-vv-as="address postcode"
                                placeholder="Postcode" v-model="addressPoscode" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressPoscode')
                            }">
                            <div v-show="validationErrors.has('addressPoscode')" class="invalid-feedback">
                                {{ validationErrors.first('addressPoscode') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <div class="mb-2">
                    <b>Operating Hours</b>
                    <div v-show="workingDaysHasError" class="text-danger">The operating hours field is required.</div>
                </div>
                <input style="opacity:0;" :class="{ 'is-invalid':  workingDaysHasError }">
                <div class="row">
                    <template v-for="workingDay in workingDays">
                        <div class="form-group d-flex justify-content-between col-12 col-lg-6" :key="workingDay.workingDayId">
                            <div class="">
                                <input class="mr-2" type="checkbox" :id="workingDay.text" :value="workingDay.workingDayId" v-model="workingDay.selected">
                                <label :for="workingDay.text">{{ workingDay.text }}</label>
                            </div>
                            <div class="">
                                <vue-timepicker
                                    :disabled="workingDay.selected === false"
                                    format="hh:mm A"
                                    v-model="workingDay.startTime"
                                    hide-clear-button
                                    class="ml-2 mr-2"
                                >
                                </vue-timepicker>
                                to
                                <vue-timepicker
                                    :disabled="workingDay.selected === false"
                                    format="hh:mm A"
                                    class="ml-2 mr-2"
                                    v-model="workingDay.endTime"
                                    hide-clear-button
                                >
                                </vue-timepicker>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="form-group mt-2">
                    <label>Operating Hours Special Remarks (Optional)</label>
                    <input type="text" placeholder="Operating Hours Special Remarks (Optional)" v-model="operatingHoursRemarks" class="form-control">
                    <small>E.g.: Lunch hours 12pm - 2pm</small>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <div class="mb-2">
                    <b>Facilities & Services</b>
                </div>

                <div class="form-group">
                    <div class="row">
                        <div class="col-6" v-for="facilityAndServiceOption in facilitiesAndServicesOptions" :key="facilityAndServiceOption">
                            <input type="checkbox" :id="facilityAndServiceOption" :value="facilityAndServiceOption" v-model="facilitiesAndServices">
                            <label class="ml-2" :for="facilityAndServiceOption">{{ facilityAndServiceOption }}</label>
                        </div>
                    </div>

                    <div class="form-group mt-2">
                        <label>Others Tests (Please Specify)</label>
                        <input type="text" name="otherFacilitiesAndServices" data-vv-validate-on="blur" data-vv-as="other facilities and services" placeholder="E.g. MRI Scan" v-model="otherFacilitiesAndServices" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('otherFacilitiesAndServices')
                        }">
                        <small>Separate by a comma (,)</small>
                        <div v-show="validationErrors.has('otherFacilitiesAndServices')" class="invalid-feedback">
                            {{ validationErrors.first('otherFacilitiesAndServices') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Clinic Registration (SSM)</b>
                        </div>
                        <div class="form-group">
                            <label>Clinic Registration (SSM) Number (Optional)</label>
                            <input type="text" name="clinicRegistrationNumber" data-vv-validate-on="blur" data-vv-as="Clinic Registration (SSM) Number"
                                placeholder="Clinic Registration (SSM) Number (Optional)" v-model="clinicRegistrationNumber" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('clinicRegistrationNumber')
                            }">
                            <div v-show="validationErrors.has('clinicRegistrationNumber')" class="invalid-feedback">
                                {{ validationErrors.first('clinicRegistrationNumber') }}
                            </div>
                        </div>
                        <div class="mt-3">
                            <div class="mb-3">
                                <b>Uploaded Document</b>

                                <div v-if="!!ssmUploadResponse.docFileNameGUID">
                                    <p>{{ssmUploadResponse.docOriFileName}}</p>
                                    <div>
                                        <a :href="`${clinicSupportingDocumentPath}${ssmUploadResponse.docFileNameGUID}`"
                                            class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                                    </div>
                                </div>
                                <div v-else class="font-italic">None</div>
                            </div>

                            <div>
                                <b>Update Document</b>
                                <clinic-supporting-document-uploader
                                    uploadButtonText="Update Document"
                                    uploadFileName="SSM document"
                                    uploadApiUrl="Profile/ClinicUploadSupportingDocument"
                                    uploadApiFileParameter="DocumentFile"
                                    :uploadApiAdditionalParameters="[{'name': 'DocumentType', 'value': 1}]"
                                    @fileUploaded="updateformSSMDocumentDetails">
                                </clinic-supporting-document-uploader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Borang B/F (Optional)</b>
                        </div>
                        <div class="form-group">
                            <label>Borang B/F Number</label>
                            <input type="text" name="borangbNumber" data-vv-validate-on="blur" data-vv-as="Borang B/F Number"
                                placeholder="Borang B/F Number" v-model="borangbNumber" v-validate="''" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('borangbNumber')
                            }">
                            <div v-show="validationErrors.has('borangbNumber')" class="invalid-feedback">
                                {{ validationErrors.first('borangbNumber') }}
                            </div>
                        </div>
                        <div class="mt-3">
                            <div class="mb-3">
                                <b>Uploaded Document</b>

                                <div v-if="!!borangBFUploadResponse.docFileNameGUID">
                                    <p>{{borangBFUploadResponse.docOriFileName}}</p>
                                    <div>
                                        <a :href="`${clinicSupportingDocumentPath}${borangBFUploadResponse.docFileNameGUID}`"
                                            class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                                    </div>
                                </div>
                                <div v-else class="font-italic">None</div>
                            </div>

                            <div>
                                <b>Update Document</b>
                                <clinic-supporting-document-uploader
                                    uploadButtonText="Update Document"
                                    uploadFileName="Borang B/F document"
                                    uploadApiUrl="Profile/ClinicUploadSupportingDocument"
                                    uploadApiFileParameter="DocumentFile"
                                    :uploadApiAdditionalParameters="[{'name': 'DocumentType', 'value': 4}]"
                                    @fileUploaded="updateformBorangBDocumentDetails">
                                </clinic-supporting-document-uploader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Doctor Malaysian Medical Certificate (MMC)</b>
                        </div>
                        <div class="form-group required">
                            <label>Doctor Malaysian Medical Certificate (MMC) Number</label>
                            <input type="text" name="doctorMmcNumber" data-vv-validate-on="blur" data-vv-as="Doctor Malaysian Medical Certificate (MMC) Number"
                                placeholder="Doctor Malaysian Medical Certificate (MMC) Number" v-model="doctorMmcNumber" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('doctorMmcNumber')
                            }">
                            <div v-show="validationErrors.has('doctorMmcNumber')" class="invalid-feedback">
                                {{ validationErrors.first('doctorMmcNumber') }}
                            </div>
                        </div>
                        <div class="mt-3">
                            <div class="mb-3">
                                <b>Uploaded Document</b>

                                <div v-if="!!mmcUploadResponse.docFileNameGUID">
                                    <p>{{mmcUploadResponse.docOriFileName}}</p>
                                    <div>
                                        <a :href="`${clinicSupportingDocumentPath}${mmcUploadResponse.docFileNameGUID}`"
                                            class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                                    </div>
                                </div>
                                <div v-else class="font-italic">None</div>
                            </div>

                            <div>
                                <b>Update Document</b>
                                <clinic-supporting-document-uploader
                                    uploadButtonText="Update Document"
                                    uploadFileName="MMC document"
                                    uploadApiUrl="Profile/ClinicUploadSupportingDocument"
                                    uploadApiFileParameter="DocumentFile"
                                    :uploadApiAdditionalParameters="[{'name': 'DocumentType', 'value': 2}]"
                                    @fileUploaded="updateformMMCDocumentDetails">
                                </clinic-supporting-document-uploader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Doctor Annual Practitioner Certificate (APC)</b>
                        </div>
                        <div class="form-group required">
                            <label>Doctor Annual Practitioner Certificate (APC) Number</label>
                            <input type="text" name="doctorApcNumber" data-vv-validate-on="blur" data-vv-as="Doctor Annual Practitioner Certificate (APC) Number"
                                placeholder="Doctor Annual Practitioner Certificate (APC) Number" v-model="doctorApcNumber" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('doctorApcNumber')
                            }">
                            <div v-show="validationErrors.has('doctorApcNumber')" class="invalid-feedback">
                                {{ validationErrors.first('doctorApcNumber') }}
                            </div>
                        </div>
                        <div class="mt-3">
                            <div class="mb-3">
                                <b>Uploaded Document</b>

                                <div v-if="!!apcUploadResponse.docFileNameGUID">
                                    <p>{{apcUploadResponse.docOriFileName}}</p>
                                    <div>
                                        <a :href="`${clinicSupportingDocumentPath}${apcUploadResponse.docFileNameGUID}`"
                                            class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                                    </div>
                                </div>
                                <div v-else class="font-italic">None</div>
                            </div>

                            <div>
                                <b>Update Document</b>
                                <clinic-supporting-document-uploader
                                    uploadButtonText="Update Document"
                                    uploadFileName="APC document"
                                    uploadApiUrl="Profile/ClinicUploadSupportingDocument"
                                    uploadApiFileParameter="DocumentFile"
                                    :uploadApiAdditionalParameters="[{'name': 'DocumentType', 'value': 3}]"
                                    @fileUploaded="updateformAPCCDocumentDetails">
                                </clinic-supporting-document-uploader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-2">
            <p v-show="isSubmitMessageShown" :class="{
                'text-danger': isSubmitMessageError
            }">
                {{submitMessage}}
            </p>
        </div>

        <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="saveProfile">
            Save Changes
        </button>
        <button type="button" class="btn btn-secondary" @click="getProfile">Cancel Changes</button>
    </div>
</template>

<script>
/* global google */
import {
    apiPath
} from '@/config';
import { googleMapsConfig } from '@/config/';
import { generateRandomId } from '@/utilities/';
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';
import facilitiesAndServicesOptions from '@/config/facilitiesAndServices';
import languages from '@/config/languages';
import changePassword from '@/components/change-password';
import ClinicSupportingDocumentUploader from '@/components/file-uploader/clinic-supporting-document-uploader';
import {
    mask
} from 'vue-the-mask';

export default {
    'components': {
        VueTimepicker,
        changePassword,
        ClinicSupportingDocumentUploader
    },
    'directives': {
        mask
    },
    'computed': {
        mapHeight () {
            return this.mapWidth;
        },
        cursorPosition () {
            let cursorWidth = 48;
            let tipOffset = 20;

            return {
                'left': `${(this.mapHeight / 2) - (cursorWidth / 2)}px`,
                'top': `${((this.mapHeight / 2) - (cursorWidth / 2)) - tipOffset}px`
            };
        },
        clinicSupportingDocumentPath () {
            return `${apiPath}Profile/ClinicSupportingDocument?fileName=`;
        }
    },
    data () {
        return {
            facilitiesAndServicesOptions,
            languages,
            'name': '',
            'email': '',
            'phone': '',
            'languagesSpeak': [],
            'internetProvider': '',
            'contactPerson': '',
            'contactPersonDesignation': '',
            'website': '',
            'fax': '',
            'clinicEmail': '',
            'clinicPhone': '',
            'otherFacilitiesAndServices': '',
            'facilitiesAndServices': [],
            'bankAccountNumber': '',
            'bankName': '',
            'bankAccountPayeeName': '',
            'lat': '',
            'long': '',
            'addressPoscode': '',
            'addressState': '',
            'addressCity': '',
            'addressLine1': '',
            'addressLine2': '',
            'workingDaysHasError': false,
            'languagesSpeakHasError': false,
            'workingDays': [
                {
                    'workingDayId': 1,
                    'startTime': '09:00 AM',
                    'endTime': '05:00 PM',
                    'text': 'Monday',
                    'selected': false
                },
                {
                    'workingDayId': 2,
                    'startTime': '09:00 AM',
                    'endTime': '05:00 PM',
                    'text': 'Tuesday',
                    'selected': false
                },
                {
                    'workingDayId': 3,
                    'startTime': '09:00 AM',
                    'endTime': '05:00 PM',
                    'text': 'Wednesday',
                    'selected': false
                },
                {
                    'workingDayId': 4,
                    'startTime': '09:00 AM',
                    'endTime': '05:00 PM',
                    'text': 'Thursday',
                    'selected': false
                },
                {
                    'workingDayId': 5,
                    'startTime': '09:00 AM',
                    'endTime': '05:00 PM',
                    'text': 'Friday',
                    'selected': false
                },
                {
                    'workingDayId': 6,
                    'startTime': '09:00 AM',
                    'endTime': '05:00 PM',
                    'text': 'Saturday',
                    'selected': false
                },
                {
                    'workingDayId': 7,
                    'startTime': '09:00 AM',
                    'endTime': '05:00 PM',
                    'text': 'Sunday',
                    'selected': false
                }
            ],
            'operatingHoursRemarks': '',
            'clinicRegistrationNumber': '',
            'borangbNumber': '',
            'doctorMmcNumber': '',
            'doctorApcNumber': '',
            'ssmUploadResponse': {
                'docFileNameGUID': '',
                'docOriFileName': ''
            },
            'borangBFUploadResponse': {
                'docFileNameGUID': '',
                'docOriFileName': ''
            },
            'mmcUploadResponse': {
                'docFileNameGUID': '',
                'docOriFileName': ''
            },
            'apcUploadResponse': {
                'docFileNameGUID': '',
                'docOriFileName': ''
            },
            'mapId': '',
            'mapDom': null,
            'searchBoxId': '',
            'searchBoxDom': null,
            'googleMapObj': null,
            'googleMapsAutoComplete': null,
            'currentAddress': '',
            'mapWidth': '',
            'isSubmitMessageShown': false,
            'isSubmitMessageError': false,
            'submitMessage': ''
        };
    },
    'methods': {
        validate () {
            let workingDayCount = 7;

            for (const workingDay of this.workingDays) {
                if (workingDay.selected === false) {
                    workingDayCount--;
                }
            }

            if (workingDayCount <= 0) {
                this.workingDaysHasError = true;
                return Promise.resolve(false);
            }

            if (this.languagesSpeak <= 0) {
                this.languagesSpeakHasError = true;
                return Promise.resolve(false);
            }

            return this.$validator.validateAll();
        },
        initGoogleMaps () {
            this.googleMapObj = new google.maps.Map(this.mapDOM, googleMapsConfig);

            let isValidLat = this.lat > -90 && this.lat < 90;
            let isValidLng = this.long > -180 && this.long < 180;
            if (isValidLat && isValidLng) {
                if (this.googleMapObj) {
                    this.googleMapObj.setCenter({
                        'lat': parseFloat(this.lat),
                        'lng': parseFloat(this.long)
                    });
                };
            }

            // Init search box, restrict places to Malaysia only.
            this.googleMapsAutoComplete = new google.maps.places.Autocomplete(this.searchBoxDOM);
            this.googleMapsAutoComplete.setComponentRestrictions({ 'country': 'my' });

            this.googleMapsAutoComplete.addListener('place_changed', () => {
                let place = this.googleMapsAutoComplete.getPlace();
                let placeGeometry = place.geometry;

                // this.form.searchLocation = place.name;
                if (placeGeometry) {
                    this.googleMapObj.setCenter(placeGeometry.location);
                }
            });

            this.googleMapObj.addListener('click', (event) => {
                this.googleMapObj.setCenter(event.latLng);
            });

            // Bias the SearchBox results towards current map's viewport.
            this.googleMapObj.addListener('bounds_changed', () => {
                this.googleMapsAutoComplete.setBounds(this.googleMapObj.getBounds());
            });
        },
        googleMapsResizeHandler () {
            if (this.googleMapObj) {
                google.maps.event.trigger(this.googleMapObj, 'resize');
            }
        },
        windowResizeHandler () {
            this.mapWidth = this.mapDOM.getBoundingClientRect().width;
        },
        getGmapLatLng () {
            if (this.googleMapObj) {
                let latLng = this.googleMapObj.getCenter();
                this.lat = latLng.lat();
                this.long = latLng.lng();
            }
        },
        formatCommaPayload (array) {
            let string = '';
            for (const [index, element] of array.entries()) {
                string = string + element;

                if (index !== array.length - 1) {
                    string = string + ',';
                }
            }

            return string;
        },
        getProfile () {
            this.axios.get('Profile/GetUserProfile').then(({ data }) => {
                const clinic = data.data;

                if (clinic.iar) {
                    this.isReviewed = true;
                    if (clinic.ia) {
                        this.isApproved = true;
                        this.isDisapproved = false;
                    } else {
                        this.isDisapproved = true;
                        this.isApproved = false;
                    }
                }

                this.name = clinic.n;
                this.email = clinic.e;
                this.phone = clinic.mn;
                this.languagesSpeak = clinic.ls ? clinic.ls.split(',') : [];
                this.lat = parseFloat(clinic.la);
                this.long = parseFloat(clinic.lo);
                this.fax = clinic.f;
                this.website = clinic.w;
                this.addressLine1 = clinic.a1;
                this.addressLine2 = clinic.a2;
                this.addressCity = clinic.ac;
                this.addressState = clinic.as;
                this.addressPoscode = clinic.ap;
                this.bankAccountPayeeName = clinic.bap;
                this.bankAccountNumber = clinic.ban;
                this.bankName = clinic.bn;
                this.contactPerson = clinic.cp;
                this.contactPersonDesignation = clinic.cpd;
                this.internetProvider = clinic.ip;
                this.facilitiesAndServices = clinic.fas ? clinic.fas.split(',') : [];
                this.mohRegistrationNumber = clinic.mrn;
                this.clinicEmail = clinic.cne;
                this.clinicPhone = clinic.cnp;
                this.clinicRegistrationNumber = clinic.crn;
                this.borangbNumber = clinic.bbfn;
                this.doctorMmcNumber = clinic.dmmcn;
                this.doctorApcNumber = clinic.dapcn;

                if (clinic.cssmd) {
                    this.ssmUploadResponse.docFileNameGUID = clinic.cssmd.fg;
                    this.ssmUploadResponse.docOriFileName = clinic.cssmd.fn;
                }

                if (clinic.bbfd) {
                    this.borangBFUploadResponse.docFileNameGUID = clinic.bbfd.fg;
                    this.borangBFUploadResponse.docOriFileName = clinic.bbfd.fn;
                }

                if (clinic.dmmcd) {
                    this.mmcUploadResponse.docFileNameGUID = clinic.dmmcd.fg;
                    this.mmcUploadResponse.docOriFileName = clinic.dmmcd.fn;
                }
                if (clinic.dapcd) {
                    this.apcUploadResponse.docFileNameGUID = clinic.dapcd.fg;
                    this.apcUploadResponse.docOriFileName = clinic.dapcd.fn;
                }

                const otherArray = this.facilitiesAndServices.filter((obj) => { return this.facilitiesAndServicesOptions.indexOf(obj) === -1; });
                this.facilitiesAndServices = this.facilitiesAndServices.filter((el) => !otherArray.includes(el));

                for (const [index, otherFacilityAndService] of otherArray.entries()) {
                    this.otherFacilitiesAndServices = this.otherFacilitiesAndServices + otherFacilityAndService;

                    if (index !== otherArray.length - 1) {
                        this.otherFacilitiesAndServices = this.otherFacilitiesAndServices + ',';
                    }
                }

                for (const clinicWorkingDay of clinic.wd) {
                    for (const workingDay of this.workingDays) {
                        if (parseFloat(clinicWorkingDay.workingDayId) === parseFloat(workingDay.workingDayId)) {
                            workingDay.selected = true;
                            workingDay.startTime = clinicWorkingDay.startTime;
                            workingDay.endTime = clinicWorkingDay.endTime;
                        }
                    }
                }

                this.operatingHoursRemarks = clinic.ohsr;

                window.addEventListener('resize', this.windowResizeHandler);
                window.addEventListener('orientationchange', this.windowResizeHandler);

                this.mapDOM = document.getElementById(this.mapId);
                this.searchBoxDOM = document.getElementById(this.searchBoxId);
                this.mapWidth = this.mapDOM.getBoundingClientRect().width;

                this.initGoogleMaps();
            });
        },
        saveProfile () {
            this.isSubmitMessageShown = true;
            this.isSubmitMessageError = false;
            Promise.all([this.validate()]).then(
                (validationResults) => {
                    this.$nextTick(() => {
                        // console.log(validationResults);
                        if (validationResults.filter(v => v === false).length > 0) {
                        // focus to the first error
                            document.body.querySelector('.is-invalid').focus();

                            this.isSubmitMessageError = true;
                            this.submitMessage = 'You have error in the form. Please check your input(s) before saving your profile.';
                        } else {
                            this.languagesSpeakHasError = false;
                            this.workingDaysHasError = false;
                            this.submitMessage = 'Saving profile...';
                            // Compile payload
                            const payload = {
                                'n': this.name,
                                'e': this.email,
                                'mn': this.phone,
                                // 'ls': this.languagesSpeak,
                                'ip': this.internetProvider,
                                'cp': this.contactPerson,
                                'cpd': this.contactPersonDesignation,
                                'w': this.website,
                                'f': this.fax,
                                'cne': this.clinicEmail,
                                'cnp': this.clinicPhone,
                                'ban': this.bankAccountNumber,
                                'bn': this.bankName,
                                'bap': this.bankAccountPayeeName,
                                'la': this.lat,
                                'lo': this.long,
                                'ap': this.addressPoscode,
                                'as': this.addressState,
                                'ac': this.addressCity,
                                'a1': this.addressLine1,
                                'a2': this.addressLine2,
                                'wd': this.workingDays.filter(workingDay => workingDay.selected === true),
                                'ohsr': this.operatingHoursRemarks,
                                'crn': this.clinicRegistrationNumber,
                                'bbfn': this.borangbNumber,
                                'dmmcn': this.doctorMmcNumber,
                                'dapcn': this.doctorApcNumber

                            };

                            // Facilities and Services
                            let facilitiesAndServices = '';
                            if (this.facilitiesAndServices.length !== 0) {
                                for (const [index, facilitiyAndService] of this.facilitiesAndServices.entries()) {
                                    facilitiesAndServices = facilitiesAndServices + facilitiyAndService;

                                    if (index !== this.facilitiesAndServices.length - 1) {
                                        facilitiesAndServices = facilitiesAndServices + ',';
                                    }
                                }
                                if (this.otherFacilitiesAndServices) {
                                    facilitiesAndServices = facilitiesAndServices + ',' + this.otherFacilitiesAndServices;
                                }
                            } else {
                                if (this.otherFacilitiesAndServices) {
                                    facilitiesAndServices = this.otherFacilitiesAndServices;
                                }
                            }

                            payload.fas = facilitiesAndServices;

                            // Language
                            payload.ls = this.formatCommaPayload(this.languagesSpeak);

                            this.axios.post('Clinic/UpdateClinicProfile', payload).then(({ data }) => {
                                this.submitMessage = 'Successfully updated profile! Your information is saved and encrypted.';
                            }).catch((error) => {
                                this.isSubmitMessageError = true;
                                if (error.response.data) {
                                    this.submitMessage = error.response.data.message;
                                } else {
                                    this.submitMessage = 'Error saving profile. Please try again.';
                                }
                            });
                        }
                    });
                });
        },
        // #region  Upload SSM
        updateformSSMDocumentDetails (documentDetails) {
            this.ssmUploadResponse.docFileNameGUID = documentDetails.fileNameGuid;
            this.ssmUploadResponse.docOriFileName = documentDetails.fileName;
        },
        // endregion
        // #region  Upload Borang B/F
        updateformBorangBDocumentDetails (documentDetails) {
            this.borangBFUploadResponse.docFileNameGUID = documentDetails.fileNameGuid;
            this.borangBFUploadResponse.docOriFileName = documentDetails.fileName;
        },
        // endregion
        // #region  Upload MMC
        updateformMMCDocumentDetails (documentDetails) {
            this.mmcUploadResponse.docFileNameGUID = documentDetails.fileNameGuid;
            this.mmcUploadResponse.docOriFileName = documentDetails.fileName;
        },
        // endregion
        // #region  Upload APC
        updateformAPCCDocumentDetails (documentDetails) {
            this.apcUploadResponse.docFileNameGUID = documentDetails.fileNameGuid;
            this.apcUploadResponse.docOriFileName = documentDetails.fileName;
        }
        // endregion
    },
    'watch': {
        mapHeight () {
            this.$nextTick(() => {
                this.googleMapsResizeHandler();
            });
        }
    },
    created () {
        this.mapId = generateRandomId();
        this.searchBoxId = generateRandomId();
    },
    mounted () {
        this.getProfile();
    },
    destroyed () {
        window.removeEventListener('resize', this.windowResizeHandler);
        window.removeEventListener('orientationchange', this.windowResizeHandler);
    }

};
</script>

<style scoped>
/*Place Detail*/
.place-map
{
    margin-bottom: 1rem;
}

.place-map > .place-gmaps-wrapper {
    position: relative;
}

.place-map .map-search-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 1em 1em 0 1em;
}

.place-map .map-edit-cursor {
    position: absolute;
    top: 0;
    width: 48px;
    height: 48px;
    background-image: url("../../assets/img/icons/location_edit.svg");
    background-size: 48px 48px;
    background-position: top left;
    background-repeat: no-repeat;
}

/* .place-map  .map-no-edit {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
} */
/*Place Detail*/

</style>
